module.exports = __webpack_public_path__ + "static/media/i78.c55922a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i78.svg
// module id = 351
// module chunks = 8